import React, { useState, useEffect, HTMLAttributes } from "react";
import axios from "axios";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";

interface DropdownProps {
  entityName: string;
  entityOptions?: any[];
  entityPath?: string;
  onEntitySelect?: (selectedEntity: any) => void;
  renderDisplay?: (
    props: HTMLAttributes<HTMLElement>,
    option: any
  ) => React.ReactNode;
}

const EntityAutocomplete: React.FC<DropdownProps> = ({
  entityName,
  entityOptions,
  entityPath,
  onEntitySelect,
  renderDisplay,
}) => {
  const [options, setOptions] = useState<any[]>([]);
  const [inputValue, setInputValue] = useState<string>("");

  useEffect(() => {
    async function fetchData() {
      if (entityOptions && entityOptions.length > 0) {
        setOptions(entityOptions);
        return;
      }

      if (entityPath && inputValue) {
        try {
          const response = await axios.post("YOUR_API_ENDPOINT", {
            searchString: inputValue,
            entityPath,
          });

          if (response.status === 200) {
            setOptions(response.data.slice(0, 5));
          } else {
            console.error("Failed to fetch data:", response.data);
          }
        } catch (error) {
          console.error("Error fetching data:", error);
        }
      }
    }

    fetchData();
  }, [inputValue, entityOptions, entityPath]);

  return (
    <Autocomplete
      options={options}
      getOptionLabel={(option) => option.name}
      onInputChange={(event, newInputValue) => {
        setInputValue(newInputValue);
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          label={entityName}
          variant="outlined"
          size="small"
          fullWidth
          autoComplete="off"
        />
      )}
      onChange={(event, value) => {
        if (onEntitySelect) {
          onEntitySelect(value);
        }
      }}
      renderOption={(props, option) => {
        if (renderDisplay) {
          return renderDisplay(props, option);
        }
        return option.name; // Default display
      }}
    />
  );
};

export default EntityAutocomplete;
